import type { ICartCRUDItem } from '../models';

import { _CartStoreFull, _CartStoreLite } from './cart-store';
import { CartLiteMapper, CartFullMapper } from '../mappers';
import { CartClient } from '@/shared/api';

const CartStoreLite = new _CartStoreLite();

CartStoreLite.injectAPIService({
  getCart: () => CartClient.getCartLite().then((r) => CartLiteMapper.getResponseFromApi(r)),
  updateCartItems: async (items: ICartCRUDItem[]) => {
    const dto = CartLiteMapper.getCartUpdateDTO(items);
    return CartClient.putCartLite(dto).then((r) => CartLiteMapper.getResponseFromApi(r));
  },
  syncCart: () => CartClient.syncCart(),
});

const CartStoreFull = new _CartStoreFull();
CartStoreFull.injectAPIService({
  getCart: async (cityId: string) => {
    return CartClient.getCartFull(cityId).then((r) => CartFullMapper.getResponseFromApi(r));
  },
  updateCartItems: async (items: ICartCRUDItem[], cityId: string) => {
    const dto = CartFullMapper.getCartUpdateDTO(items);
    return CartClient.putCartFull(dto, cityId).then((r) => CartFullMapper.getResponseFromApi(r));
  },
  syncCart: () => CartClient.syncCart(),
});

/** синхронизируем lite-корзину по респонту full */
CartStoreFull.cartResponse.onCartResponseUpdate(() => {
  const resp = CartStoreFull.getLiteResponse();
  if (!resp) return;

  CartStoreLite.setResponse(resp);
});

export { CartStoreLite, CartStoreFull };
